import { Button, Typography, TextField, Grid, FormControl, FormControlLabel, Checkbox } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { setStyle } from "../../util";
import Layout from "../Layout";
import Signup from "./Authentication/Signup";
import { AuthenticationService, LoginForm } from "../../services/authentication/AuthenticationService";
import { useNavigate } from "react-router";

const ForgetPassword = () => {
    const { defaultValues } = useContext(AppContext);
    const { server, setServer, socket } = useContext(AppContext);
    const navigate = useNavigate()

    useEffect(() => {
        if (defaultValues) { setStyle(defaultValues); }
    })

    // Email
    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");

    function handleEmailFocusLoss() {
        if (email.length === 0) { setEmailError("Vous devez spécifier une adresse courriel."); }
        else if (!email.includes('@') || !email.includes('.')) {
            setEmailError("L'adresse courriel est invalide.");
        } else {
            setEmailError("");
        }
    }

    const onForgotPassword = () => {
        handleEmailFocusLoss();

        if (
            email.length > 0 
        ) {
            AuthenticationService.forgot(email);
        }
    }

    return (
        <Layout>
    
            <Grid className="container-grande-marge"> 
                <Grid className="container-form">
                    <h2 className="serious-title" >Mot de passe oublié</h2>
                    <Typography variant='caption' gutterBottom>Changement de mot de passe.</Typography>
                        
                    <TextField
                        className="serious-input"
                        fullWidth
                        error={emailError.length > 0}
                        helperText={emailError}
                        value={email}
                        onChange={(e) => { setEmail(e.target.value); }}
                        onBlur={handleEmailFocusLoss}
                        label='Courriel'
                        variant="outlined"
                        sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                        InputLabelProps={{
                                shrink: true,
                            }} />

                    
                    <Button onClick={onForgotPassword} variant='contained' className="serious-btn" >Changement du mot de passe</Button>
                    
                </Grid>   
            </Grid>
        
        
        </Layout>
    );
};



export default ForgetPassword;